const minutesToAdd = 59;

export default function roundHourUp(time) {
  return time.add(minutesToAdd, 'minutes').startOf('hour');
}
